import { L, } from '../leaflet/leaflet';
import { _$map, } from './map';
const L_featureGroup = L.featureGroup, _$viewMarkerGroup = L_featureGroup(), _$editMarkerGroup = L_featureGroup(), _$lineGroup = L_featureGroup();
_$viewMarkerGroup.addTo(_$map);
_$editMarkerGroup.addTo(_$map);
_$lineGroup.addTo(_$map);
export { _$viewMarkerGroup, _$editMarkerGroup, _$lineGroup, };
